import React from 'react';
import { MdEmail, MdPhone, MdLocationOn } from 'react-icons/md';
import { FaLinkedin, FaBehance, FaInstagram } from 'react-icons/fa';
import { motion } from 'framer-motion';

const FooterSection = () => (
  <footer className="bg-gray-100 py-10 md:py-12 mt-16 font-sans">
    <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 px-4">
      {/* Contact Info */}
      <div>
        <h3 className="text-lg md:text-xl font-bold mb-4">Contact Me</h3>
        <div className="space-y-4">
          <p className="text-gray-700 text-base flex items-center gap-3">
            <MdEmail className="text-xl text-gray-600" />
            <motion.a
              href="mailto:a.danielboateng@gmail.com"
              className="font-semibold text-black underline underline-offset-2 hover:text-black focus:text-black transition"
              whileHover={{ scale: 1.08, color: '#000' }}
              whileTap={{ scale: 0.96 }}
            >
              a.danielboateng@gmail.com
            </motion.a>
          </p>
          <p className="text-gray-700 text-base flex items-center gap-3">
            <MdPhone className="text-xl text-gray-600" />
            <span className="font-semibold"></span> (020) 252-2357
          </p>
          <p className="text-gray-700 text-base flex items-center gap-3">
            <MdLocationOn className="text-xl text-gray-600" />
            <span className="font-semibold"></span> Tema, Ghana
          </p>
        </div>
      </div>
      {/* Social Links */}
      <div>
        <h3 className="text-lg md:text-xl font-bold mb-4">Connect With Me</h3>
        <div className="flex gap-6 text-2xl text-gray-500">
          <a 
            href="https://www.linkedin.com/in/daniel-adi-boateng-9371051a7" 
            target="_blank" 
            rel="noopener noreferrer" 
            aria-label="LinkedIn" 
            className="hover:text-[#0077B5] transition-colors duration-300"
          >
            <FaLinkedin />
          </a>
          <a 
            href="https://www.behance.net/danieladi4" 
            target="_blank" 
            rel="noopener noreferrer" 
            aria-label="Behance" 
            className="hover:text-[#1769FF] transition-colors duration-300"
          >
            <FaBehance />
          </a>
          <a 
            href="https://www.instagram.com/n.yconcept" 
            target="_blank" 
            rel="noopener noreferrer" 
            aria-label="Instagram" 
            className="hover:text-[#E4405F] transition-colors duration-300"
          >
            <FaInstagram />
          </a>
        </div>
      </div>
    </div>
    <div className="text-center text-gray-400 text-sm mt-8">&copy; 2025 NY Concept. All rights reserved.</div>
  </footer>
);

export default FooterSection; 